import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { RequestFormPhone } from '~/src/components/RequestFormPhone';

const breakPoints = {
    mobile: '767px',
};

export const Wrapper = styled.section<{ backgroundImg: string }>`
    display: block;
    width: 100%;
    background-color: #0A0D11;
    background-image: url(${({ backgroundImg }) => backgroundImg});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: top center;
    border-radius: 0 0 32px 32px;
    padding-bottom: 32px;
    overflow: hidden;

    @media (max-width: ${wideBreakpoints.mobile}) {
        background-size: 200%;
        background-position: top right;
    }
`;

export const FeaturesWrapper = styled.div`
    @media (min-width: ${wideBreakpoints.mobile}) {
        margin: 32px 0;
    }
`;

export const TabsTitle = styled.h2`
    ${FONTS.H2};
    color: ${COLORS.white};
    margin: 32px 0 16px 0;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H3};
    }
`;

export const CardsTitle = styled.h2`
    ${FONTS.H2};
    color: ${COLORS.white};
    margin-top: 32px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 64px;
    }
`;

export const Desc = styled.div`
    display: block;
    width: 100%;
    margin-top: 140px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-top: 110px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-top: 80px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 350px;
    }
`;

export const Form = styled.div`
    display: block;
    width: 100%;
    margin-top: 36px;
`;

export const Cards = styled.div`
    display: block;
    width: 100%;
    margin-top: 32px;
`;

export const SRequestFormPhone = styled(RequestFormPhone)`
    label {
        color: ${COLORS.GRAY_LIGHT};

        @media (max-width: ${wideBreakpoints.mobile}) {
            ${FONTS.XXS};
        }

        a {
            color: ${COLORS.GRAY_LIGHT};
            border-bottom: 1px solid ${COLORS.GRAY_LIGHT};
        }
    }

    > div > div {
         > button {
            @media (max-width: ${breakPoints.mobile}) {
                width: 100%;
            }
         }
    }
`;
